"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const core_1 = require("@emotion/core");
const framer_motion_1 = require("framer-motion");
const constants_1 = __importStar(require("@/constants"));
const forms_1 = require("@/forms");
const styled_react_1 = __importDefault(require("./styled-react"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const thanks_feedback_1 = __importDefault(require("./thanks-feedback"));
const SupportMessage = ({ setMessageType, resetSupportMessage, messageType, messageSent, }) => (core_1.jsx(framer_motion_1.motion.div, { className: styles_scss_1.default.mobileSupportMessageContainer, initial: { opacity: 0, y: 500 }, animate: { opacity: 1, y: 0 } },
    core_1.jsx("div", { className: styles_scss_1.default.header },
        core_1.jsx("button", { className: styles_scss_1.default.closeBtn, css: styled_react_1.default.layoutCloseBtn(constants_1.Images.greyClose), onClick: () => {
                resetSupportMessage();
                setMessageType(null);
            }, type: "button" }),
        core_1.jsx("h3", null, constants_1.default.support.title[messageType])),
    messageSent ? (core_1.jsx("div", { className: styles_scss_1.default.feedbackContainer },
        core_1.jsx(thanks_feedback_1.default, null))) : (core_1.jsx("div", { className: styles_scss_1.default.formContainer },
        core_1.jsx(forms_1.SupportForm, { type: messageType })))));
exports.default = SupportMessage;
